import React, {useEffect} from 'react';
import {Image, theme, ChakraProvider, Flex, Text, Button} from '@chakra-ui/react';
import CheckImg from '../assets/img/check_circle.svg';
import ErrorImg from '../assets/img/error.svg';
export const SelectoionPopUpCard = (props) =>{
  
    return(
      <ChakraProvider theme={theme}>
        <Flex alignItems="center" justifyContent="center" className="pop-cand-resp" h="100%" position="fixed" zIndex="910" m="0 auto" top="0" bg="#857f7f6e">
        <Flex alignItems="center" justifyContent="center" flexDirection="column" bg="white" borderRadius="20" pt="5" pb="5" m="4" boxShadow="0px 10px 40px 0px rgb(0 0 0 / 12%)">
        <Image 
        src={CheckImg}
        alt="Select Img"
        w="90px"
        h="90px"
        />
        <Text
        color="#222222"
        fontSize="30px"
        fontWeight="700"
        textAlign="center">
        Selection Saved
        </Text>
        <Text
        textAlign="center"
        color="#666666"
        fontSize="15px"
        pt="3"
        pb="7"
        fontWeight="400"
        pr="4"
        pl="4">
        You can login to you account anytime to access your cart selection 
        </Text>
        <Button
            color="#FA2F45"
            bg="white"
            h="10"
            w="86%"
            borderRadius="20"
            border="1px solid #FA2F45"
            onClick={() => props.SaveBtn(true)}>
                   Ok, got it!
        </Button>
        </Flex>
        </Flex>
    </ChakraProvider>
)}

export const CartPopUpCard = (props) =>{
  
  return(
    <ChakraProvider theme={theme}>
       <Flex alignItems="center" justifyContent="center" className="pop-cand-resp" h="100%" position="fixed" zIndex="910" m="0 auto" top="0" bg="#857f7f6e">
        <Flex alignItems="center" justifyContent="center" flexDirection="column" bg="white" borderRadius="20" pt="5" pb="5" m="4" boxShadow="0px 10px 40px 0px rgb(0 0 0 / 12%)">
        <Text
        textAlign="center"
        color="#666666"
        fontSize="15px"
        pt="3"
        pb="7"
        fontWeight="500"
        pr="4"
        pl="4">
        Are you sure you want to remove this photo from your cart?
        </Text>
        <Flex justifyContent="space-around" w="100%" pt="4">
          <Button
            color="#FA2F45"
            bg="white"
            h="10"
            borderRadius="20"
            border="1px solid #FA2F45"
            onClick={() => {props.RemoveBtn(props.CartIndex);props.KeepItBtn(true)}}>
                   Yes, Remove
           </Button>
           <Button
            color="white"
            bg="#FA2F45"         
            h="10"
            borderRadius="20"
            onClick={() => props.KeepItBtn(true)}
            >
                   Keep in cart
           </Button>
        </Flex>
        </Flex>
        </Flex>
  </ChakraProvider>
)}

export const SingleCartPopUpCard = (props) =>{
  
  return(
    <ChakraProvider theme={theme}>
       <Flex alignItems="center" justifyContent="center" className="pop-cand-resp" h="100%" position="fixed" zIndex="910" m="0 auto" top="0" bg="#857f7f6e">
        <Flex alignItems="center" justifyContent="center" flexDirection="column" bg="white" borderRadius="20" pt="5" pb="5" m="4" boxShadow="0px 10px 40px 0px rgb(0 0 0 / 12%)">
        <Text
        textAlign="center"
        color="#666666"
        fontSize="15px"
        pt="3"
        pb="7"
        fontWeight="500"
        pr="4"
        pl="4">
        Are you sure you want to remove this photo from your cart?
        </Text>
        <Flex justifyContent="space-around" w="100%" pt="4">
          <Button
            color="#FA2F45"
            bg="white"
            h="10"
            borderRadius="20"
            border="1px solid #FA2F45"
            onClick={() => {props.RemoveSingleItemBtn(props.SingleSlideIndex);props.KeepSingleItBtn()}}>
                   Yes, Remove
           </Button>
           <Button
            color="white"
            bg="#FA2F45"         
            h="10"
            borderRadius="20"
            onClick={() => {props.KeepSingleItBtn()}}
            >Keep in cart
           </Button>
        </Flex>
        </Flex>
        </Flex>
  </ChakraProvider>
)}

export const ErrorPopUpCard = (props) =>{
  useEffect( () => {
    if(props.ErrorCardShow === true){
  setTimeout(
    () => props.SetErrorCardShow(false), 3000)
  }}, [])

  return(
    <ChakraProvider theme={theme}>
      <Flex onClick={e => props.SetErrorCardShow(false)} alignItems="center" justifyContent="center" className="pop-cand-resp" h="100%" position="fixed" zIndex="910" m="0 auto" top="0" bg="#857f7f6e">
      <Flex alignItems="center" justifyContent="center" flexDirection="column" bg="white" borderRadius="20" pt="5" pb="5" m="4" boxShadow="0px 10px 40px 0px rgb(0 0 0 / 12%)">
      <Image 
      src={ErrorImg}
      alt="Select Img"
      w="50px"
      h="50px"
      />
      <Text
      color="#222222"
      fontSize="30px"
      fontWeight="700"
      textAlign="center">
      Error
      </Text>
      <Text
      textAlign="center"
      color="#666666"
      fontSize="15px"
      pt="3"
      pb="7"
      fontWeight="400"
      pr="4"
      pl="4">
      {props.ErrorCardMsg}
      </Text>
      </Flex>
      </Flex>
  </ChakraProvider>
)}

export const ErrorToast = (props) =>{
  useEffect( () => {
    if(props.ErrorCardShow === true){
  setTimeout(
    () => props.SetErrorCardShow(false), 2000)
  }}, [])

  return(
    <ChakraProvider theme={theme}>
      <Flex onClick={e => props.SetErrorCardShow(false)}  alignItems="center" justifyContent="center" className="pop-cand-resp" h="100%" position="fixed" zIndex="910" m="0 auto" top="0" bg="#857f7f6e">
      <Flex alignItems="center" justifyContent="center" flexDirection="column" bg="white" borderRadius="20" pt="5" pb="5" m="4" boxShadow="0px 10px 40px 0px rgb(0 0 0 / 12%)">
      
      <Text
      id="snackbar"
      textAlign="center"
      color="#666666"
      fontSize="15px"
      pt="3"
      pb="7"
      fontWeight="400"
      pr="4"
      pl="4">
      {props.ErrorCardMsg}
      </Text>
      </Flex>
      </Flex>
  </ChakraProvider>
)}